import { HttpMethod, RequestOptions, useUserRequest } from "../common/lib/fetch";
import { UpsertKioskDto } from "./dtos/UpsertKioskDto";

const useUpdateKiosk = (siteId: string, kioskId: string, options: RequestOptions) =>
  useUserRequest<UpsertKioskDto>({
    path: `/api/sites/${siteId}/kiosks/${kioskId}`,
    method: HttpMethod.PUT
  }, options);

export default useUpdateKiosk;